import AddIcon from '@mui/icons-material/Add'
import {
    Button, ListItemIcon, ListItemText, MenuItem,
} from '@mui/material'
import useStyles
    from './SkyBaseCreateButton.styles'

export default function SkyBaseCreateButton({
    isMenuItem = false,
    onClick,
}: Readonly<{
    isMenuItem?: boolean,
    onClick: () => void
}>) {
    const {
        classes,
    } = useStyles()

    if (isMenuItem) {
        return (
            <MenuItem
                onClick={onClick}
                data-testid="create-menu-item"
            >
                <ListItemIcon>
                    <div className={classes.button}>
                        <AddIcon
                            className={classes.icon}
                        />
                    </div>
                </ListItemIcon>
                <ListItemText>
                    Add New
                </ListItemText>
            </MenuItem>
        )
    }

    return (
        <Button
            className={classes.button}
            onClick={onClick}
            type="button"
            data-testid="create-button"
        >
            <AddIcon
                className={classes.icon}
            />
        </Button>
    )
}
